exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".homeTitle{\n\tfont-family: 'Marvel','sans-serif';\n\tfont-size:30px;\n\tline-height:1.3em;\n\tcolor: #444;\n}\n.sub{\n\tbackground-color:#FFF5EE;\n\tpadding-bottom: 5px;\n\tpadding-top: 5px;\n\tpadding-left: 20px;\n}\n.p1{\n\tbackground-color: #F5DEB3;\n    text-align:right;\n    padding-right:4%;\n}\n.p2{\n\tbackground-color:#FFEFD5;\n    text-align:right;\n    padding-right:4%;\n}\n.tbl{\n    width:700px;\n    margin-left:120px;\n    margin-bottom: 30px;\n    margin-top: 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/academics/courseOffered.component.css
// module id = ../../../../../src/app/academics/courseOffered.component.css
// module chunks = main